import { useSelector } from 'react-redux';
import { getAllowedUserPermissions } from '../../helpers/common';
import { isAdminRole, CHILDREN_TAB_RECEIVED_BOXES } from '../../consts/management/users/users';

export default function useWarehouseEditAccess() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  if (isAdminRole(currentUser?.role)) return true;
  const { childIdToAccess } = getAllowedUserPermissions({
    permissions: currentUser?.permissions || [],
  });
  return childIdToAccess.get(CHILDREN_TAB_RECEIVED_BOXES) === 'edit';
}
